module.exports = __webpack_public_path__ + "static/media/onepong.42613d3d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/onepong.gif
// module id = 92
// module chunks = 0